export default __webpack_public_path__ + "media/images/images_v2/borderright3-60b3a8033f0d9df1707312ac3befd489.png";